/**
 * Roles Catalog Service
 * HTTP operations for roles catalog
 */

import { apiClient, API_CONFIG } from '@/api/core';
import type { ApiResponse } from '@/api/shared';
import type { LC_GetRolesCatalogOut, RoleCatalog } from './roles.types';
import { mapRolesCatalog } from './roles.mapper';


export class RoleCatalogService {
  /**
   * Get roles catalog
   * GET /v{version}/catalog/roles
   */
  async getRoles(): Promise<ApiResponse<RoleCatalog[]>> {
    const endpoint = API_CONFIG.ENDPOINTS.CATALOG.ROLES;
    const response = await apiClient.get<LC_GetRolesCatalogOut>(endpoint);

    if (!response.success || !response.data) {
      return { ...response, data: null };
    }

    return { ...response, data: mapRolesCatalog(response.data) };
  }
}

export const roleCatalogService = new RoleCatalogService();
